import React from 'react';
import { useTabContentContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import Fade from '@mui/material/Fade';
import FacetPlanNextUpScenarioReviewLayout
  from 'Views/Page/Content/Templates/FacetPlanProposalNextUpReviewPageTemplate/FacetPlanNextUpScenarioReview';
import { FDBox } from '@facet-wealth/design';

const NextUpTabTemplate = () => {
  const { activeTabResource, setActiveTabResourceType } = useTabContentContext();
  return (
    <FDBox paddingX={4} maxHeight={'100%'} height={'100%'}>
      <Fade in timeout={500}>
        <div>{/* The component below can return null, and Fade requires children or else it blows up */}
          <FacetPlanNextUpScenarioReviewLayout resource={activeTabResource} setActiveTabResourceType={setActiveTabResourceType} />
        </div>
      </Fade>
    </FDBox>
  );
};

NextUpTabTemplate.defaultProps = {};

NextUpTabTemplate.propTypes = {};

export default NextUpTabTemplate;
